export const linking = {
  prefixes: ["/"],
  config: {
    screens: {
      lead: "lead",

      insert_mobile: "auth/login",
      verify_code: "auth/verify-code",

      home: "",
      organization: "organization",

      attributes: "attributes",
      attribute: "attribute/:id",

      notes: "notes",
      note: "note",

      reminders: "reminders",
      reminder: "reminder",

      wholesalers: "wholesalers",
      employee_permissions: "employee-permissions",
      apk_version: "apk-version",
      type_of_meeting: "type-of-meeting",
      company_profile: "company-profile",

      // employee_permissions: { user_id?: number; name?: string };

      // corp: { corp?: CorpT };
      // corps: 'undefined';
      // CEOs: 'undefined';
      // CEO: 'undefined';

      // user: { user?: {} };
      // users: 'undefined';

      // type_of_meeting: 'undefined';
      // apk_version: 'undefined';

      // admins: 'undefined';
      // admin: { id?: number };

      // sellers: 'undefined';
      // seller: { id?: number };
      // seller_tasks: { id?: number; name?: string };
      // seller_charts: { id?: number; name?: string };

      // wholesalers: 'wholesalers';
      // wholesaler: 'wholesaler';

      // categories: 'categories';
      // category: { id?: number };

      // products: 'products';
      // product: { id?: number; catId?: number };

      // customers: ICustomersRoute;
      // customer: RouteDetailsT;
      // customerTabs: CustomerTabT;
      // customersTabs: {
      //   id: number;
      //   target?: "add_reminder" | "add_factor" | "add_note";
      // };

      // customer_reminders: CustomerT;

      // factors: IFactorsRoute;
      // factor: RouteDetailsT;

      // reports: 'reports',

      // history: 'history',

      // account: 'account',

      // profile: 'profile',
      // contact_us: 'contact-us',
      // about_us: 'about-us',

      // companies: 'companies',
      // test: 'test';

      // company: { id: number };
      // report: { type: "seller" | "sale" | "product" | "customer"; link: string };
      // customer_notes: CustomerT;
      // all_today_reminders: { data: [] };
    },
  },
};
